import { defineStore } from "pinia";

export const useProcessModelStore = defineStore('processModel', {
  state: () => ({
    processModel: {},
    processModels: [],
    loading: false,
  }),
  actions: {
    setLoading(state, loading) {
      state.loading = loading
    },
    setProcessModel(processModel) {
      this.processModel = processModel
    },
    setProcessModels(processModels) {
      this.processModels = processModels
    },
    addProcessModel(processModel) {
      this.processModels.unshift(processModel)
    },
    updateProcessModel(processModel) {
      let index = this.processModels.findIndex(cl => cl.id === processModel.id)
      this.processModels.splice(index, 1, processModel)
    },
    deleteProcessModel(processModel) {
      let index = this.processModels.findIndex(cl => cl.id === processModel.id)
      this.processModels.splice(index, 1)
    },
  },
});